MS = window.MS || {};

(function($) {

  var $window = $(window);
  var $document = $(document);
  var $html = $('html');
  var $body = $('body');
  var $hero = $('.ms-ss_module__hero');

  MS.sultrysalt_scroll_progress = {


    init: function () {

      var _this = this;

      // The scroll progress element
      this.$element = $('.ms-ss_module__scroll-progress');

      if ( !this.$element.length ) {
        return;
      }

      // The scrub element
      this.$scrub = $('.ms-ss_module__scroll-progress__progress');

      // Bind resize
      $window.on('resize', function () {
        _this.updateMetrics();
        _this.onScroll();
      });

      // Start tracking scroll
      this.startScrollTracking();

    },


    updateMetrics: function () {

      // Hero height
      this.heroHeight = $hero[0].offsetHeight;

      // Full document height
      this.documentHeight = Math.max( $body[0].scrollHeight, $body[0].offsetHeight, $html[0].clientHeight, $html[0].scrollHeight, $html[0].offsetHeight );

      // Max scroll
      this.maxScroll = this.documentHeight - window.innerHeight - this.heroHeight;

    },


    // Initializes scroll tracking
    startScrollTracking: function () {

      // Stop existing tracker
      this.untrackScroll();

      if ( !this.$element.length ) { return; }

      // Save essential metrics
      this.updateMetrics();

      // Bind scroll
      $window.on('scroll', this.onScroll.bind(this));

    },


    // Stops scroll tracking
    untrackScroll: function () {
      $window.off('scroll', this.onScroll.bind(this));
    },


    // Fires every scroll event
    onScroll: function () {

      this.updateMetrics();

      // Get current scroll
      var currentScroll = window.pageYOffset - this.heroHeight;

      // Compute for how much percentage
      var scrollProgressRatio = currentScroll / this.maxScroll;

      // Apply ratio into the scrub
      this.$scrub.css('transform', 'scaleX(' + scrollProgressRatio + ')');

    }


  };

})(jQuery);
